// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonLightIntensity_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11 1H13V5H11V1Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 18.1973C16.7934 17.1599 18 15.2208 18 13C18 9.68629 15.3137 7 12 7C8.68629 7 6 9.68629 6 13C6 15.2208 7.2066 17.1599 9 18.1973V19H15V18.1973ZM12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" class="svg-bg"/>
  <path d="M20 14H24V12H20V14ZM4 12V14H0V12H4ZM5.63657 8.0502 7.05078 6.63599 4.22235 3.80756 2.80814 5.22177 5.63657 8.0502ZM18.3633 8.05054 16.9491 6.63632 19.7775 3.8079 21.1917 5.22211 18.3633 8.05054ZM9 23V21H15V23H9Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 2H15V8H17V2Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 18C24 20.9611 22.3912 23.5465 20 24.9297V26H12V24.9297C9.60879 23.5465 8 20.9611 8 18C8 13.5817 11.5817 10 16 10C20.4183 10 24 13.5817 24 18ZM22 18C22 21.3137 19.3137 24 16 24C12.6863 24 10 21.3137 10 18C10 14.6863 12.6863 12 16 12C19.3137 12 22 14.6863 22 18Z" class="svg-bg"/>
  <path d="M32 19H26V17H32V19ZM6 19V17H0V19H6ZM9.63599 10.2227 8.22177 11.6369 3.97913 7.39423 5.39335 5.98002 9.63599 10.2227ZM22.3644 10.2225 23.7786 11.6367 28.0212 7.39408 26.607 5.97987 22.3644 10.2225ZM20 30V28H12V30H20Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonLightIntensity is a generated icon component.
 */
let IconCommonLightIntensity = IconCommonLightIntensity_1 = class IconCommonLightIntensity extends IconBaseElement {
    render() {
        return html `${IconCommonLightIntensity_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonLightIntensity.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonLightIntensity = IconCommonLightIntensity_1 = __decorate([
    customElement('zui-icon-common-light-intensity')
], IconCommonLightIntensity);
export { IconCommonLightIntensity };
